import { createAction } from "@reduxjs/toolkit";
import {
  getProfileActionTypes,
  updateProfileActionTypes,
  setProfileActionType,
  clearProfileStatesActionType,
  uploadAvatarActionTypes,
  deleteAvatarActionTypes,
  deleteBannerActionTypes,
  uploadBannerActionTypes,
  clearAvatarSuccessActionType,
  clearAvatarErrorActionType,
  setMySubscriptionActionType,
  addMySubscriptionActionType,
  removeMySubscriptionActionType,
  reorderSubscriptionsActionType,
  incrementPostsCounterActionType,
  decrementPostsCounterActionType,
  disconnectMetamaskActionTypes,
  disconnectPayoutMethodActionTypes,
  disconnectPayPalActionTypes,
  deleteAccountActionTypes,
  setContentShareTourTypes,
  resetProfileActiveStreamType,
  resetProfileUpcomingStreamType,
} from "./actionTypes";

export const setProfile = createAction(setProfileActionType, (payload) => ({
  payload,
}));

export const getProfile = createAction(getProfileActionTypes.request);

export const getProfileSuccess = createAction(
  getProfileActionTypes.success,
  (payload) => ({ payload }),
);

export const getProfileFailure = createAction(
  getProfileActionTypes.failure,
  (error) => ({ payload: error }),
);

export const updateProfile = createAction(updateProfileActionTypes.request);

export const updateProfileSuccess = createAction(
  updateProfileActionTypes.success,
  (payload) => ({ payload }),
);

export const updateProfileFailure = createAction(
  updateProfileActionTypes.failure,
  (error) => ({ payload: error }),
);

export const uploadAvatar = createAction(uploadAvatarActionTypes.request);

export const uploadAvatarSuccess = createAction(
  uploadAvatarActionTypes.success,
  (payload) => ({ payload }),
);

export const uploadAvatarFailure = createAction(
  uploadAvatarActionTypes.failure,
  (error) => ({ payload: error }),
);

export const deleteAvatar = createAction(deleteAvatarActionTypes.request);

export const deleteAvatarSuccess = createAction(
  deleteAvatarActionTypes.success,
  (payload) => ({ payload }),
);

export const deleteAvatarFailure = createAction(
  deleteAvatarActionTypes.failure,
  (error) => ({ payload: error }),
);

export const uploadBanner = createAction(uploadBannerActionTypes.request);

export const uploadBannerSuccess = createAction(
  uploadBannerActionTypes.success,
  (payload) => ({ payload }),
);

export const uploadBannerFailure = createAction(
  uploadBannerActionTypes.failure,
  (error) => ({ payload: error }),
);

export const deleteBanner = createAction(deleteBannerActionTypes.request);

export const deleteBannerSuccess = createAction(
  deleteBannerActionTypes.success,
  (payload) => ({ payload }),
);

export const deleteBannerFailure = createAction(
  deleteBannerActionTypes.failure,
  (error) => ({ payload: error }),
);

export const clearProfileStates = createAction(clearProfileStatesActionType);

export const clearAvatarSuccess = createAction(clearAvatarSuccessActionType);

export const clearAvatarError = createAction(clearAvatarErrorActionType);

export const setMySubscription = createAction(
  setMySubscriptionActionType,
  (payload) => ({ payload }),
);

export const addMySubscription = createAction(
  addMySubscriptionActionType,
  (payload) => ({ payload }),
);

export const removeMySubscription = createAction(
  removeMySubscriptionActionType,
  (payload) => ({ payload }),
);

export const reorderSubscriptions = createAction(
  reorderSubscriptionsActionType,
  (payload) => ({ payload }),
);

export const incrementPostsCounter = createAction(
  incrementPostsCounterActionType,
);

export const decrementPostsCounter = createAction(
  decrementPostsCounterActionType,
);

export const disconnectMetamask = createAction(
  disconnectMetamaskActionTypes.request,
);
export const disconnectMetamaskSuccess = createAction(
  disconnectMetamaskActionTypes.success,
);
export const disconnectMetamaskFailure = createAction(
  disconnectMetamaskActionTypes.failure,
);

export const disconnectPayoutMethod = createAction(
  disconnectPayoutMethodActionTypes.request,
);
export const disconnectPayoutMethodSuccess = createAction(
  disconnectPayoutMethodActionTypes.success,
);
export const disconnectPayoutMethodFailure = createAction(
  disconnectPayoutMethodActionTypes.failure,
);

export const disconnectPayPal = createAction(
  disconnectPayPalActionTypes.request,
);
export const disconnectPayPalSuccess = createAction(
  disconnectPayPalActionTypes.success,
);
export const disconnectPayPalFailure = createAction(
  disconnectPayPalActionTypes.failure,
);

export const deleteAccount = createAction(deleteAccountActionTypes.request);
export const deleteAccountSuccess = createAction(
  deleteAccountActionTypes.success,
);
export const deleteAccountFailure = createAction(
  deleteAccountActionTypes.failure,
);

export const setContentShareTour = createAction(
  setContentShareTourTypes.request,
);
export const setContentShareTourSuccess = createAction(
  setContentShareTourTypes.success,
);
export const setContentShareTourFailure = createAction(
  setContentShareTourTypes.failure,
);
export const resetProfileActiveStream = createAction(
  resetProfileActiveStreamType,
);
export const resetProfileUpcomingStream = createAction(
  resetProfileUpcomingStreamType,
);
